module.exports = require("ethereum-cryptography/hdkey");